import { z } from 'zod';

export const companyProfileTranslationSchema = z.object({
    locale: z.string().max(5).min(5),
    text: z.string(),
});

export type CompanyProfileTranslation = z.infer<typeof companyProfileTranslationSchema>;

export const companyProfileSchema = z.object({
    description: companyProfileTranslationSchema.array().optional(),
    name: z.string(),
    priorities: companyProfileTranslationSchema.array().optional(),
    size: z.number().int().min(1).default(500),
});

export type CompanyProfile = z.infer<typeof companyProfileSchema>;

export const companyProfileUpdateSchema = z.object({
    description: companyProfileTranslationSchema.array().optional(),
    name: z.string().optional(),
    priorities: companyProfileTranslationSchema.array().optional(),
    size: z.number().int().min(1).optional(),
});

export type CompanyProfileUpdate = z.infer<typeof companyProfileUpdateSchema>;
